export interface ProductFiltersValue {
  status: string[];
  type: string[];
  productGroup: string[];
  isBatchManaged: boolean | undefined;
  belowMinStock: boolean;
  expiringWithinDays: number | undefined;
  activeOnly: boolean;
}

export const EMPTY_PRODUCT_FILTERS: ProductFiltersValue = {
  status: [],
  type: [],
  productGroup: [],
  isBatchManaged: undefined,
  belowMinStock: false,
  expiringWithinDays: undefined,
  activeOnly: false,
};

export function hasActiveProductFilters(value: ProductFiltersValue): boolean {
  return (
    value.status.length > 0 ||
    value.type.length > 0 ||
    value.productGroup.length > 0 ||
    value.isBatchManaged !== undefined ||
    value.belowMinStock ||
    value.expiringWithinDays !== undefined ||
    value.activeOnly
  );
}
